
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#B4C3C4"}}),_c('path',{attrs:{"d":"M10 8l.707.707a1 1 0 000-1.414L10 8zm-3.707 2.293a1 1 0 101.414 1.414l-1.414-1.414zm1.414-6a1 1 0 00-1.414 1.414l1.414-1.414zm1.586 3l-3 3 1.414 1.414 3-3-1.414-1.414zm-3-1.586l3 3 1.414-1.414-3-3-1.414 1.414z","fill":"#fff"}})])
          )
        }
      }
    